export default {
    backend_url: 'https://' + process.env.REACT_APP_BACKEND_URL
}